import moment from "moment";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useGetProjectsSummary } from "../hooks/useGetProjectsSummary";
import Skeleton from "react-loading-skeleton";
import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import { useClientContext } from "../../../hooks/ClientContext";
import { ThemedSpan } from "../../../components/utilities";

function ProjectSummaryDetails() {
    const today = new Date();
    const { data, error, isLoading, loadMore, hasMore, totalProjectValue, totalCount } = useGetProjectsSummary();
    const openMasterAccount = useOpenMasterAccount();
    const { id: masterAccountId } = useClientContext();

    if (isLoading) return (
        <Skeleton height={300} />
    )

    if (error) return <p>Error loading data</p>;
    if (!data || data.length < 1) {
        return null;
    }

    const onProjectSelected = (e, masterAccountId, projectId) => {
        e.preventDefault();
        const suffix = projectId ? `projects?projectId=${projectId}` : "projects";
        openMasterAccount(masterAccountId, { suffix })
    }

    return (
        <>
            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                <Card style={{ height: "auto" }}>
                    <Card.Body className="position-relative">
                        <Card.Title>
                            <Row>
                                <Col className="col-sm-3 col-md-6" style={{ fontSize: "18px", paddingBottom: "20px" }}>
                                    <a className="text-reset text-decoration-none" href={`/client/${masterAccountId}/projects`}
                                        onClick={(e) => onProjectSelected(e, masterAccountId, null)}>
                                        <ThemedSpan variant="primary" className="fw-bold" style={{ fontSize: "18px", margin: "1px", cursor: "pointer" }}>
                                            Projects <ThemedSpan variant="primary" className="fw-normal"style={{ fontSize: "14px" }}> ({totalCount} total)</ThemedSpan>
                                        </ThemedSpan></a>
                                </Col>
                                <Col className="col-sm-3 col-md-6 text-end" style={{ fontSize: "18px", color: "purple" }}>
                                    <p >Total Fee Potential: {totalProjectValue.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })}</p>
                                </Col>
                            </Row>
                        </Card.Title>
                        <Card.Text as="div">
                            {data.map((item, i) => (
                                <Row key={i} style={{ cursor: "default" }}>
                                    <Col className="col-6">
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id={`tooltip-${item.id}`}>
                                                <span>Status: {item.statusDescription}</span><br />
                                                <span>Project Value: {item.projectValue.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })}</span>
                                            </Tooltip>}>
                                            <a className="text-reset text-decoration-none" href={`/client/${item.masterAccountId}/projects?projectId=${item.projectId}`}
                                                onClick={(e) => onProjectSelected(e, item.masterAccountId, item.projectId)}><p><ThemedSpan variant="primary">{item.description}</ThemedSpan></p>
                                            </a>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col className="col-6 font-monospace text-end">
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={<Tooltip id={`tooltip-${item.id}`}>
                                                <span>Status: {item.statusDescription}</span><br />
                                                <span>Project Value: {item.projectValue.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })}</span>
                                            </Tooltip>}>
                                            <p style={{ color: new Date(item.targetDate) < today ? 'red' : 'black' }}> {moment(item.targetDate).format('DD/MM/YYYY')}</p>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            ))
                            }
                            {hasMore && (
                                <p className="text-black cursor-pointer text-decoration-underline fw-bold text-center" onClick={loadMore}>
                                    See More...
                                </p>
                            )}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}

export default ProjectSummaryDetails;